import React, { useEffect } from "react";
import { Table } from "antd";
import { ColumnsType } from "antd/es/table";
import { useCceModel } from "../cceModel";
import { useDictModel } from "@/views/base/dict/dictModel";
import { ICceDetail } from "../cceTypes";
import { formatNum } from "@/utils/utils";


export function DataTable() {
    const {
        dataSource, selectedRowKeys, pgCfg, loading,
        loadData, setSelectedRowKeys
    } = useCceModel();

    const { getTreeNodeName, getTreeNodeValue } = useDictModel(() => []);

    useEffect(() => {
        loadData()
    }, [])

    const columns: ColumnsType<ICceDetail> = [
        {
            title: '序号',
            width: 45,
            fixed: "left",
            dataIndex: "totalTxt",
            render: (t: any, r: any, i: number) => <>{t ? t : i + 1}</>
        }, {
            title: '信用证号',
            width: 160,
            dataIndex: 'code',
            fixed: "left",
        }, {
            title: '状态',
            width: 100,
            fixed: "left",
            dataIndex: 'status',
            render: text => text === 0 ? '已登记' : '已收汇'
        }, {
            title: '外贸合同号',
            width: 160,
            dataIndex: 'saleRealCode',
            fixed: "left",
        }, {
            title: '开证人',
            width: 160,
            dataIndex: 'opener',
            ellipsis: true,
        }, {
            title: '签发日期',
            width: 160,
            dataIndex: 'signingTime',
            ellipsis: true,
        }, {
            title: '到证日期',
            width: 160,
            dataIndex: 'confirmTime',
            ellipsis: true,
        }, {
            title: '币种',
            width: 80,
            dataIndex: "currency",
            render: text => getTreeNodeName(text)
        }, {
            title: '开证金额',
            width: 200,
            dataIndex: "amount",
        }, {
            title: '收汇金额',
            width: 180,
            dataIndex: 'receiptPrice',
        }, {
            title: '信用证类型',
            width: 100,
            dataIndex: 'creditType',
            render: text => getTreeNodeName(text)
        }, {
            title: '业务员',
            width: 100,
            dataIndex: 'createUser',
        }, {
            title: '备注',
            width: 100,
            dataIndex: 'note',
        }
    ];


    //点击行选高亮
    const onRow = (code: string) => {
        let findIndex = selectedRowKeys.indexOf(code);
        let newSelectedRowKeys = [...selectedRowKeys];
        if (findIndex === -1) {
            newSelectedRowKeys.push(code);
            setSelectedRowKeys(newSelectedRowKeys);
        } else {
            newSelectedRowKeys.splice(findIndex, 1);
            setSelectedRowKeys(newSelectedRowKeys);
        }
    };


    return (
        <Table
            rowKey={record => record.id}
            loading={loading}
            rowSelection={{
                //全部选中时  (存string[])
                getCheckboxProps: (record) => {
                    let checkboxProps: any = {};
                    if (record.code === "listTotalAmount") {
                        checkboxProps.disabled = true;
                    }
                    return checkboxProps;
                },
                onSelectAll: (selected, selectedRows, changeRows) => {
                    let changeRowId = changeRows.map(item => item.id).filter(item => item !== "listTotalAmount");
                    selected ? setSelectedRowKeys((origin) => [...origin, ...changeRowId])
                        : setSelectedRowKeys((origin) => origin.filter(item => changeRowId.indexOf(item) < 0));
                },
                onSelect: (record) => onRow(record.id),
                selectedRowKeys: selectedRowKeys
            }}
            columns={columns}
            dataSource={dataSource}
            pagination={{
                ...pgCfg,
                position: ["bottomCenter"],
                showTotal: () => `共${pgCfg.total}条`,
                onChange: (pageNum, pageSize) => {
                    loadData({ pageNum, pageSize })
                }
            }}
            onRow={record => ({
                onClick: () => onRow(record.id),
                onContextMenu: (e) => {
                    e.preventDefault();
                    setSelectedRowKeys([record.id]);
                }
            })}
            scroll={{ x: 'max-content', y: "calc(100vh - 360px)" }}
        />
    )
}
